import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, withCtx as _withCtx, vShow as _vShow, withDirectives as _withDirectives, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-296eb4aa")

_pushScopeId("data-v-296eb4aa")
const _hoisted_1 = { class: "page" }
const _hoisted_2 = { class: "p-hd" }
const _hoisted_3 = {
  key: 0,
  class: "wrapper p-main"
}
const _hoisted_4 = { class: "s-hd" }
const _hoisted_5 = { class: "avatar-wrap" }
const _hoisted_6 = { class: "u-name" }
const _hoisted_7 = {
  key: 0,
  class: "count-down"
}
const _hoisted_8 = { class: "time" }
const _hoisted_9 = /*#__PURE__*/_createVNode("p", null, "总剩余时间", -1)
const _hoisted_10 = { class: "s-bd" }
const _hoisted_11 = /*#__PURE__*/_createVNode("p", { class: "p-tit" }, "题卡", -1)
const _hoisted_12 = { class: "p-qnum" }
const _hoisted_13 = /*#__PURE__*/_createTextVNode(" 总题数：")
const _hoisted_14 = { key: 0 }
const _hoisted_15 = { class: "s-ft" }
const _hoisted_16 = { class: "btns" }
const _hoisted_17 = /*#__PURE__*/_createTextVNode("提交")
const _hoisted_18 = /*#__PURE__*/_createTextVNode("保存")
const _hoisted_19 = /*#__PURE__*/_createTextVNode("交卷")
const _hoisted_20 = /*#__PURE__*/_createVNode("ul", { class: "flag" }, [
  /*#__PURE__*/_createVNode("li", { class: "q-done" }, "已做"),
  /*#__PURE__*/_createVNode("li", null, "未做")
], -1)
const _hoisted_21 = { class: "q-area-main" }
const _hoisted_22 = { key: 0 }
const _hoisted_23 = { class: "ft" }
const _hoisted_24 = /*#__PURE__*/_createTextVNode("上一页")
const _hoisted_25 = /*#__PURE__*/_createTextVNode("下一页")
const _hoisted_26 = /*#__PURE__*/_createTextVNode("提交")
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_answer_head = _resolveComponent("answer-head")
  const _component_el_button = _resolveComponent("el-button")
  const _component_single_choice = _resolveComponent("single-choice")
  const _component_multiple_choice = _resolveComponent("multiple-choice")
  const _component_completion = _resolveComponent("completion")
  const _component_q_a = _resolveComponent("q-a")
  const _component_program = _resolveComponent("program")
  const _component_program_panel = _resolveComponent("program-panel")
  const _component_el_empty = _resolveComponent("el-empty")

  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode("div", _hoisted_1, [
      _createVNode("div", _hoisted_2, [
        _createVNode(_component_answer_head, {
          title: _ctx.questionContent.examName,
          wrapper: true,
          goBack: _ctx.handleGoBack
        }, null, 8, ["title", "goBack"])
      ]),
      (_ctx.questionContent.question)
        ? (_openBlock(), _createBlock("div", _hoisted_3, [
            _createVNode("div", {
              class: 'side-sheet' + (_ctx.sideSheetFixed ? ' fixed' : ''),
              ref: "sideSheet",
              style: { left: _ctx.sideSheetFixed ? _ctx.sideSheetPos.x + 'px' : 0, top: _ctx.sideSheetFixed ? _ctx.sideSheetPos.y + 'px' : 0 }
            }, [
              _createVNode("div", _hoisted_4, [
                _createVNode("div", _hoisted_5, [
                  (_ctx.userInfo['id'])
                    ? (_openBlock(), _createBlock("img", {
                        key: 0,
                        src: _ctx.userInfo['avatar'] ? _ctx.userInfo['avatar'] : _ctx.defaultImg,
                        class: "avatar",
                        onerror: `onerror=null;src='${_ctx.defaultImg}'`
                      }, null, 8, ["src", "onerror"]))
                    : _createCommentVNode("", true)
                ]),
                _createVNode("p", _hoisted_6, _toDisplayString(_ctx.userInfo['nickname']), 1),
                (_ctx.isExam)
                  ? (_openBlock(), _createBlock("div", _hoisted_7, [
                      _createVNode("p", _hoisted_8, _toDisplayString(_ctx.timeRemain), 1),
                      _hoisted_9
                    ]))
                  : _createCommentVNode("", true)
              ]),
              _createVNode("div", _hoisted_10, [
                _hoisted_11,
                _createVNode("p", _hoisted_12, [
                  _hoisted_13,
                  _createVNode("span", null, _toDisplayString(_ctx.questionContent.questionNum), 1)
                ]),
                _createVNode("dl", null, [
                  (_ctx.questionContent.newQuestion && _ctx.questionContent.newQuestion.length)
                    ? (_openBlock(true), _createBlock(_Fragment, { key: 0 }, _renderList(_ctx.questionContent.newQuestion, (item) => {
                        return (_openBlock(), _createBlock(_Fragment, {
                          key: item.id
                        }, [
                          (item.sort === 1)
                            ? (_openBlock(), _createBlock("dt", _hoisted_14, [
                                (item.questionType === 1)
                                  ? (_openBlock(), _createBlock(_Fragment, { key: 0 }, [
                                      _createTextVNode(_toDisplayString(_ctx.questionContent.singleChoiceIndex) + "、" + _toDisplayString(_ctx.questionTypeNameMap[item.questionType - 1]), 1)
                                    ], 64))
                                  : _createCommentVNode("", true),
                                (item.questionType === 2)
                                  ? (_openBlock(), _createBlock(_Fragment, { key: 1 }, [
                                      _createTextVNode(_toDisplayString(_ctx.questionContent.multipleChoiceIndex) + "、" + _toDisplayString(_ctx.questionTypeNameMap[item.questionType - 1]), 1)
                                    ], 64))
                                  : _createCommentVNode("", true),
                                (item.questionType === 3)
                                  ? (_openBlock(), _createBlock(_Fragment, { key: 2 }, [
                                      _createTextVNode(_toDisplayString(_ctx.questionContent.gapFillingIndex) + "、" + _toDisplayString(_ctx.questionTypeNameMap[item.questionType - 1]), 1)
                                    ], 64))
                                  : _createCommentVNode("", true),
                                (item.questionType === 4)
                                  ? (_openBlock(), _createBlock(_Fragment, { key: 3 }, [
                                      _createTextVNode(_toDisplayString(_ctx.questionContent.questionsIndex) + "、" + _toDisplayString(_ctx.questionTypeNameMap[item.questionType - 1]), 1)
                                    ], 64))
                                  : _createCommentVNode("", true),
                                (item.questionType === 5)
                                  ? (_openBlock(), _createBlock(_Fragment, { key: 4 }, [
                                      _createTextVNode(_toDisplayString(_ctx.questionContent.programmeIndex) + "、" + _toDisplayString(_ctx.questionTypeNameMap[item.questionType - 1]), 1)
                                    ], 64))
                                  : _createCommentVNode("", true)
                              ]))
                            : _createCommentVNode("", true),
                          _createVNode("dd", null, [
                            _createVNode(_component_el_button, {
                              class: "q-btn",
                              size: "mini",
                              type: item.status ? 'primary' : 'default',
                              onClick: ($event: any) => (_ctx.go2Question(item.totalSort))
                            }, {
                              default: _withId(() => [
                                _createTextVNode(_toDisplayString(item.sort), 1)
                              ]),
                              _: 2
                            }, 1032, ["type", "onClick"])
                          ])
                        ], 64))
                      }), 128))
                    : _createCommentVNode("", true)
                ])
              ]),
              _createVNode("div", _hoisted_15, [
                _createVNode("div", _hoisted_16, [
                  (!_ctx.isExam && !_ctx.isAnswer)
                    ? (_openBlock(), _createBlock(_component_el_button, {
                        key: 0,
                        class: "btn",
                        type: "primary",
                        onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.saveOrCommitPaper(2)))
                      }, {
                        default: _withId(() => [
                          _hoisted_17
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true),
                  (_ctx.isExam)
                    ? (_openBlock(), _createBlock(_component_el_button, {
                        key: 1,
                        class: "btn btn-save",
                        type: "primary",
                        plain: "",
                        onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.saveOrCommitPaper2(1)))
                      }, {
                        default: _withId(() => [
                          _hoisted_18
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true),
                  (_ctx.isExam)
                    ? (_openBlock(), _createBlock(_component_el_button, {
                        key: 2,
                        class: "btn",
                        type: "primary",
                        onClick: _ctx.beforeCommitPaper
                      }, {
                        default: _withId(() => [
                          _hoisted_19
                        ]),
                        _: 1
                      }, 8, ["onClick"]))
                    : _createCommentVNode("", true)
                ]),
                _hoisted_20
              ])
            ], 6),
            _createVNode("div", {
              class: `q-area ${_ctx.questionContent.shortcutKeyAstrict ? 'limited' : ''}`
            }, [
              _createVNode("div", _hoisted_21, [
                _createVNode("dl", null, [
                  (_ctx.questionContent.newQuestion && _ctx.questionContent.newQuestion.length)
                    ? (_openBlock(true), _createBlock(_Fragment, { key: 0 }, _renderList(_ctx.questionContent.newQuestion, (item) => {
                        return (_openBlock(), _createBlock(_Fragment, {
                          key: item.id
                        }, [
                          (item.sort === 1 && item.totalSort >= _ctx.sortStart && item.totalSort <= _ctx.sortEnd)
                            ? (_openBlock(), _createBlock("dt", _hoisted_22, [
                                (item.questionType === 1)
                                  ? (_openBlock(), _createBlock(_Fragment, { key: 0 }, [
                                      _createTextVNode(_toDisplayString(_ctx.questionContent.singleChoiceIndex) + "、" + _toDisplayString(_ctx.questionTypeNameMap[item.questionType - 1]), 1)
                                    ], 64))
                                  : _createCommentVNode("", true),
                                (item.questionType === 2)
                                  ? (_openBlock(), _createBlock(_Fragment, { key: 1 }, [
                                      _createTextVNode(_toDisplayString(_ctx.questionContent.multipleChoiceIndex) + "、" + _toDisplayString(_ctx.questionTypeNameMap[item.questionType - 1]), 1)
                                    ], 64))
                                  : _createCommentVNode("", true),
                                (item.questionType === 3)
                                  ? (_openBlock(), _createBlock(_Fragment, { key: 2 }, [
                                      _createTextVNode(_toDisplayString(_ctx.questionContent.gapFillingIndex) + "、" + _toDisplayString(_ctx.questionTypeNameMap[item.questionType - 1]), 1)
                                    ], 64))
                                  : _createCommentVNode("", true),
                                (item.questionType === 4)
                                  ? (_openBlock(), _createBlock(_Fragment, { key: 3 }, [
                                      _createTextVNode(_toDisplayString(_ctx.questionContent.questionsIndex) + "、" + _toDisplayString(_ctx.questionTypeNameMap[item.questionType - 1]), 1)
                                    ], 64))
                                  : _createCommentVNode("", true),
                                (item.questionType === 5)
                                  ? (_openBlock(), _createBlock(_Fragment, { key: 4 }, [
                                      _createTextVNode(_toDisplayString(_ctx.questionContent.programmeIndex) + "、" + _toDisplayString(_ctx.questionTypeNameMap[item.questionType - 1]), 1)
                                    ], 64))
                                  : _createCommentVNode("", true)
                              ]))
                            : _createCommentVNode("", true),
                          _withDirectives(_createVNode("dd", {
                            ref: 'q' + item.totalSort
                          }, [
                            (item.questionType === 1)
                              ? (_openBlock(), _createBlock(_component_single_choice, {
                                  key: 0,
                                  quesData: item,
                                  onChange: _ctx.handleAnswerChange,
                                  showAnswer: _ctx.isAnswer
                                }, null, 8, ["quesData", "onChange", "showAnswer"]))
                              : _createCommentVNode("", true),
                            (item.questionType === 2)
                              ? (_openBlock(), _createBlock(_component_multiple_choice, {
                                  key: 1,
                                  quesData: item,
                                  onChange: _ctx.handleAnswerChange,
                                  showAnswer: _ctx.isAnswer
                                }, null, 8, ["quesData", "onChange", "showAnswer"]))
                              : _createCommentVNode("", true),
                            (item.questionType === 3)
                              ? (_openBlock(), _createBlock(_component_completion, {
                                  key: 2,
                                  quesData: item,
                                  onChange: _ctx.handleAnswerChange,
                                  showAnswer: _ctx.isAnswer
                                }, null, 8, ["quesData", "onChange", "showAnswer"]))
                              : _createCommentVNode("", true),
                            (item.questionType === 4)
                              ? (_openBlock(), _createBlock(_component_q_a, {
                                  key: 3,
                                  quesData: item,
                                  onChange: _ctx.handleAnswerChange,
                                  showAnswer: _ctx.isAnswer
                                }, null, 8, ["quesData", "onChange", "showAnswer"]))
                              : _createCommentVNode("", true),
                            (item.questionType === 5)
                              ? (_openBlock(), _createBlock(_component_program, {
                                  key: 4,
                                  quesData: item,
                                  onStartProgram: () => _ctx.handleStartProgram(item),
                                  showAnswer: _ctx.isAnswer
                                }, null, 8, ["quesData", "onStartProgram", "showAnswer"]))
                              : _createCommentVNode("", true)
                          ], 512), [
                            [_vShow, item.totalSort >= _ctx.sortStart && item.totalSort <= _ctx.sortEnd]
                          ])
                        ], 64))
                      }), 128))
                    : _createCommentVNode("", true)
                ]),
                _createVNode("div", _hoisted_23, [
                  (_ctx.page > 1)
                    ? (_openBlock(), _createBlock(_component_el_button, {
                        key: 0,
                        type: "primary",
                        plain: "",
                        class: "btn btn-prev",
                        onClick: _ctx.go2PrevPage
                      }, {
                        default: _withId(() => [
                          _hoisted_24
                        ]),
                        _: 1
                      }, 8, ["onClick"]))
                    : _createCommentVNode("", true),
                  (_ctx.page < _ctx.maxPage)
                    ? (_openBlock(), _createBlock(_component_el_button, {
                        key: 1,
                        type: "primary",
                        class: "btn",
                        onClick: _ctx.go2NextPage
                      }, {
                        default: _withId(() => [
                          _hoisted_25
                        ]),
                        _: 1
                      }, 8, ["onClick"]))
                    : _createCommentVNode("", true),
                  (!_ctx.isAnswer && _ctx.page === _ctx.maxPage)
                    ? (_openBlock(), _createBlock(_component_el_button, {
                        key: 2,
                        type: "primary",
                        class: "btn",
                        onClick: _ctx.beforeCommitPaper
                      }, {
                        default: _withId(() => [
                          _hoisted_26
                        ]),
                        _: 1
                      }, 8, ["onClick"]))
                    : _createCommentVNode("", true)
                ])
              ])
            ], 2)
          ]))
        : _createCommentVNode("", true),
      (_ctx.showProgramPanel)
        ? (_openBlock(), _createBlock(_component_program_panel, {
            key: 1,
            isSingQuesMod: false,
            isExam: _ctx.isExam,
            title: _ctx.questionContent.examName,
            time: _ctx.timeRemain,
            quesData: _ctx.currProgramData,
            onClose: _ctx.handleCloseProgramPanel,
            onSave: _ctx.handleAnswerChange,
            canNotSelectQuestion: !!_ctx.questionContent.shortcutKeyAstrict
          }, null, 8, ["isExam", "title", "time", "quesData", "onClose", "onSave", "canNotSelectQuestion"]))
        : _createCommentVNode("", true)
    ]),
    (!_ctx.questionContent.question)
      ? (_openBlock(), _createBlock(_component_el_empty, {
          key: 0,
          description: "暂无内容",
          "image-size": 100,
          class: "paper-empty"
        }))
      : _createCommentVNode("", true)
  ], 64))
})